import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Phase 12: auth lives in the httpOnly `cf_token` cookie. `withCredentials:true`
// makes the browser attach it to every request. No more Bearer header from the
// frontend — the cookie can't be exfiltrated by XSS.
// Phase 13.1: 120s timeout covers compare-mode (3 LLMs in parallel) and Sora 2
// thumbnail generation. Cloudflare edge times out at ~100s, so this also lets
// the browser show a clean error instead of hanging forever on edge timeouts.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 120_000,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Clear any stale cached user so the UI can route to /auth.
      localStorage.removeItem("cf_user");
      // Legacy cleanup: remove any cf_token lingering from pre-Phase-12 sessions.
      localStorage.removeItem("cf_token");
    }
    return Promise.reject(err);
  }
);
